import React, { useEffect, useState } from "react";
import FoodShell from "../../layouts/FoodShell";
import { appModules } from "../../components/global";
import { GET, Select, alert } from "../../components/CustomComponent";
import { restaurants, goalOptions } from "./mockData";
import { Panel, Chip, ReasonList } from "./FoodUi";

const radiusOptions = [
  { value: "500", label: "ไม่เกิน 500 ม." },
  { value: "1000", label: "ไม่เกิน 1 กม." },
  { value: "2000", label: "ไม่เกิน 2 กม." },
];
const sortOptions = [
  { value: "ai", label: "AI แนะนำ" },
  { value: "distance", label: "ใกล้ที่สุด" },
  { value: "price", label: "ถูกที่สุด" },
  { value: "rating", label: "คะแนนสูงสุด" },
];

// ร้านอาหารใกล้ฉัน: หาเมนูใกล้ตัวแล้วกรองตามโปรไฟล์ AI อธิบายว่าทำไมเลือกร้านนั้น (ข้อมูลจำลอง)
export default function FoodNearby() {
  const { title, description } = appModules["food_nearby"];
  const [radius, setRadius] = useState("1000");
  const [sort, setSort] = useState("ai");
  const [openOnly, setOpenOnly] = useState(true);
  // หน้านี้ยังเป็นตัวอย่าง (ข้อ 12 ยังไม่ทำ): ร้านเป็นข้อมูลจำลอง แต่เป้าหมาย/งบอ่านจากโปรไฟล์จริง
  const [userProfile, setUserProfile] = useState(null);
  useEffect(() => {
    GET("v1/food/profile", null, null, { silent: true }).then((result) => result?.status === true && setUserProfile(result.data));
  }, []);

  const goal = goalOptions.find((item) => item.value === userProfile?.goal)?.label || "ทั่วไป";
  const budgetText = userProfile?.budget_min || userProfile?.budget_max ? `฿${userProfile.budget_min || 0}–${userProfile.budget_max || "∞"}` : "ยังไม่ตั้ง";
  const list = restaurants
    .filter((item) => item.distance <= Number(radius) && (!openOnly || item.open))
    .sort((a, b) => (sort === "distance" ? a.distance - b.distance : sort === "price" ? a.price - b.price : sort === "rating" ? b.rating - a.rating : Number(b.picked) - Number(a.picked) || a.distance - b.distance));
  const picked = list.find((item) => item.picked);

  return (
    <FoodShell title={title} description={description}>
      <Panel
        eyebrow="Nearby"
        icon="fa-solid fa-location-dot"
        title="กินข้าวแถวนี้"
        desc={`(ตัวอย่าง ยังไม่เชื่อมข้อมูลร้านจริง) กรองตามเป้าหมาย "${goal}" งบต่อมื้อ ${budgetText} และเมนูที่คุณชอบ`}
        actions={
          <button type="button" className="btn stg-btn stg-btn--ghost" onClick={() => alert("", "info", "ตำแหน่งปัจจุบัน", "ใช้ตำแหน่ง: ที่ทำงาน (จำลอง ยังไม่ขอ GPS จริง)")}>
            <i className="fa-solid fa-crosshairs" />ที่ทำงาน
          </button>
        }
      >
        <div className="row g-2 mb-3 align-items-center">
          <div className="col-md-3"><Select className="form-control" value={radius} options={radiusOptions} onChange={setRadius} /></div>
          <div className="col-md-3"><Select className="form-control" value={sort} options={sortOptions} onChange={setSort} /></div>
          <div className="col-md-6 d-flex flex-wrap gap-1 align-items-center">
            <Chip tone="muted" active={openOnly} onClick={() => setOpenOnly(!openOnly)} icon={openOnly ? "fa-solid fa-check" : "fa-regular fa-circle"}>เฉพาะร้านที่เปิดอยู่</Chip>
            <Chip tone="orange" icon="fa-solid fa-filter">ตรงเป้าหมาย</Chip>
            <Chip tone="orange" icon="fa-solid fa-filter">ในงบ</Chip>
          </div>
        </div>

        {picked ? (
          <div className="food-aipick mb-3">
            <div className="food-aipick-head">
              <span className="food-pick-badge"><i className="fa-solid fa-robot" />วันนี้ผมเลือก {picked.name} ให้คุณ</span>
            </div>
            <div className="food-aipick-body">
              <div className="food-aipick-menu">
                <span className="food-pick-emoji">{picked.emoji}</span>
                <div>
                  <div className="food-pick-name">{picked.menu}</div>
                  <div className="food-pick-stats">
                    <span>ประมาณ <strong>{picked.kcal}</strong> kcal</span>
                    <span>โปรตีน <strong>{picked.protein}</strong></span>
                    <span>ราคา <strong>฿{picked.price}</strong></span>
                    <span><i className="fa-solid fa-person-walking" /> {picked.distance} ม. · {picked.minutes} นาที</span>
                  </div>
                </div>
              </div>
              <ReasonList light reasons={["โปรตีนสูงกว่าตัวเลือกอื่นในระยะเดียวกัน", "ยังอยู่ในงบมื้อกลางวัน", "ใกล้ที่ทำงาน เดินถึงใน 5 นาที", "ไม่ซ้ำกับมื้อเมื่อวาน"]} />
            </div>
          </div>
        ) : null}

        <div className="food-shops">
          {list.length ? list.map((shop) => (
            <div key={shop.id} className={`food-shop ${shop.picked ? "is-picked" : ""} ${shop.open ? "" : "is-closed"}`}>
              <div className="food-shop-emoji">{shop.emoji}</div>
              <div className="food-shop-main">
                <div className="food-shop-head">
                  <span className="food-shop-name">{shop.name}</span>
                  <span className="food-shop-rating"><i className="fa-solid fa-star" />{shop.rating}</span>
                  {shop.picked ? <span className="stg-pill stg-pill--gold stg-pill--plain"><i className="fa-solid fa-robot" /> AI เลือก</span> : null}
                  {!shop.open ? <span className="stg-pill stg-pill--muted">ปิดอยู่</span> : null}
                </div>
                <div className="food-shop-menu">{shop.menu}</div>
                <div className="food-nutri">
                  <span><i className="fa-solid fa-fire" />ประมาณ {shop.kcal} kcal</span>
                  <span><i className="fa-solid fa-drumstick-bite" />โปรตีน{shop.protein}</span>
                  <span><i className="fa-solid fa-person-walking" />{shop.distance} ม. · {shop.minutes} นาที</span>
                </div>
                <div className="mt-1 d-flex flex-wrap gap-1">{shop.tags.map((tag) => <Chip key={tag} tone="orange">{tag}</Chip>)}</div>
              </div>
              <div className="food-shop-side">
                <div className="food-shop-price">฿{shop.price}</div>
                <button type="button" className="btn stg-btn stg-btn--primary stg-btn--sm" disabled={!shop.open} onClick={() => alert("", "success", "บันทึกแล้ว", `เลือก ${shop.menu} จาก ${shop.name} (จำลอง)`)}>เลือกร้านนี้</button>
                <button type="button" className="btn stg-btn stg-btn--ghost stg-btn--sm" onClick={() => alert("", "info", "นำทาง", "เปิดแผนที่ (จำลอง)")}><i className="fa-solid fa-diamond-turn-right" />นำทาง</button>
              </div>
            </div>
          )) : <div className="stg-empty"><i className="fa-solid fa-store-slash" />ไม่มีร้านในระยะที่เลือก ลองขยายระยะทาง</div>}
        </div>
      </Panel>
    </FoodShell>
  );
}
